"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        collapsed: Boolean,
        collapsedSize: String,
        collapsible: Boolean,
        contentUrl: String,
        max: String,
        min: String,
        resizable: Boolean,
        scrollable: Boolean,
        size: String
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-layout-vue-wrapper/dist/es/KendoSplitter/PaneProps.js
// module id = 676
// module chunks = 0